'use client'

import { AppShell, AppShellMain, Box, Flex, Stack, Text, Title, Button, ThemeIcon, Space, Skeleton } from '@mantine/core'
import { IconFileUnknown } from '@tabler/icons-react'
import { GeneralMedicineFooter } from '@/components/Footer'
import ResponsiveLayout from '@/components/Layouts/ResponsiveLayout'
import { useUserContext } from '@/contexts/UserContext'
import Link from 'next/link'
import { useState, useEffect } from 'react'

export default function NotFound() {
    const { fetchUser, user } = useUserContext()
    const [hasFetchedUser, setHasFetchedUser] = useState(false)
    const isLoggedIn = !!user

    useEffect(() => {
        if (!user) {
            const promise = fetchUser()
            if (promise) {
                promise.finally(() => setHasFetchedUser(true))
            } else {
                // fetchUser was throttled and returned undefined
                setHasFetchedUser(true)
            }
        } else {
            setHasFetchedUser(true)
        }
    }, [user, fetchUser])

    return (
        <div style={{ overflowX: 'hidden' }}>
            <AppShell>
                <AppShellMain component="div">
                    <ResponsiveLayout>
                        <Flex
                            direction="column"
                            align="center"
                            justify={{ base: 'flex-start', xs: 'center' }}
                            h={{ base: '85vh', xs: '70vh' }}
                            pt={{ base: '20vh', xs: 0 }}
                        >
                            <Stack gap="xs" align="center">
                                <ThemeIcon
                                    variant="light"
                                    size={90}
                                    style={{ backgroundColor: '#FDA71226' }}
                                >
                                    <IconFileUnknown strokeWidth={1.3} size={60} color="#9D530F" />
                                </ThemeIcon>
                                <Space h="xs" />
                                <Title order={2} ta="center">
                                    Page not found
                                </Title>
                                <Text c="var(--gm-fg-primary-black)" ta="center">
                                    We couldn&apos;t find the page you&apos;re looking for.
                                    <br />
                                    Double-check the URL or try again.
                                </Text>
                                {/* Button inline with content on xs+ */}
                                {hasFetchedUser ? (
                                    <Button mt="sm" component={Link} href={isLoggedIn ? '/account' : '/'} size="md" fullWidth visibleFrom="xs">
                                        {isLoggedIn ? 'Back to account' : 'Back to home'}
                                    </Button>
                                ) : (
                                    <Skeleton mt="sm" height={42} width="100%" radius="xl" visibleFrom="xs" />
                                )}
                            </Stack>
                            {/* Button near bottom on mobile */}
                            <Box hiddenFrom="xs" style={{ marginTop: 'auto', marginBottom: '60px', width: '100%' }}>
                                {hasFetchedUser ? (
                                    <Button component={Link} href={isLoggedIn ? '/account' : '/'} size="md" fullWidth>
                                        {isLoggedIn ? 'Back to account' : 'Back to home'}
                                    </Button>
                                ) : (
                                    <Skeleton height={42} width="100%" radius="xl" />
                                )}
                            </Box>
                        </Flex>
                    </ResponsiveLayout>
                </AppShellMain>
            </AppShell>
            <GeneralMedicineFooter />
        </div>
    )
}
